'use strict';

require('../../style/index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/icon/style/css.js
// module id = 55
// module chunks = 0